module.exports = __webpack_public_path__ + "static/media/story-header.e57fb0aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/story-header.jpg
// module id = 362
// module chunks = 0